import { render, staticRenderFns } from "./CreateUsersQuestion.vue?vue&type=template&id=0f87fc9a&scoped=true"
import script from "./CreateUsersQuestion.vue?vue&type=script&lang=js"
export * from "./CreateUsersQuestion.vue?vue&type=script&lang=js"
import style0 from "./CreateUsersQuestion.vue?vue&type=style&index=0&id=0f87fc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87fc9a",
  null
  
)

export default component.exports